import Swiper from 'vendor_components/swiper.min';

function TravelSwiper() {
    const $element = document.querySelector('.js-travelBlock');
    const $swiper = $element.querySelector('.swiper');

    new Swiper($swiper, {
        slidesPerView: 'auto',
        speed: 300,
        navigation: {
            prevEl: $element.querySelector('.Travel__prev'),
            nextEl: $element.querySelector('.Travel__next'),
        },
        pagination: {
            el: '.Travel__pagination',
            clickable: true,
            bulletElement: 'div',
            bulletClass: 'Travel__bullet',
            bulletActiveClass: 'Travel__bullet--active',
            type: 'bullets',
        },
        breakpoints: {
            960: {
                slidesPerView: 4,
                spaceBetween: 20,
                pagination: false
            },
        },
    });
}

export default TravelSwiper;
